module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iIQDC"))).then(() => parcelRequire('kSkug'));